import { eq, flow, get } from 'lodash/fp';
import { filter, map } from 'rxjs/operators';
import { combineEpics, ofType } from 'redux-observable';
import { ACTIONS } from 'redux-api-call';
import { CREATE_CREDIT_TRANSACTION_API_ID } from '../../apiCalls/creditSystem/create';
import routerHistory from '../../routerHistory';

const handleCreateCreditTransactionSuccess = actions$ =>
  actions$.pipe(
    ofType(ACTIONS.COMPLETE),
    filter(flow(get('payload.name'), eq(CREATE_CREDIT_TRANSACTION_API_ID))),
    map(() => {
      routerHistory.push(`/payment/credits/records`);
    })
  );

export default combineEpics(handleCreateCreditTransactionSuccess);
